
import { computed, defineComponent, onMounted, reactive, ref, inject } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus'
import { useStore } from '../store/index'
import { ThemeProps } from '../store/template'
export default defineComponent({
  name: 'Template',
  setup() {
    const baseAPIURL = inject('baseAPIURL')
    const store = useStore()
    const dialogVisible = ref(false)
    const editMode = ref('')
    const templates = computed(() => store.state.template.data)
    const isLoading = computed(() => store.getters.isLoading)
    const formData = ref({
      name: '',
      title: '',
      desc: '',
      coverImage: '',
      componentName: '',
      themes: [] as ThemeProps[],
      columns: '',
      publicLink: '',
      isPro: false
    })
    const triggerEdit = (index: number) => {
      dialogVisible.value = true
      console.log(templates.value[index])
      const { name, desc = '', coverImage = '', _id, componentName, themes, title = '', columns, publicLink = '', isPro = false } = templates.value[index]
      editMode.value = _id
      formData.value = {
        name,
        componentName,
        themes,
        title,
        desc,
        publicLink,
        coverImage,
        columns,
        isPro
      }
      // schema.properties.coverImage.default = coverImage
    }
    const schema = reactive({
      type: 'object',
      definitions: {
        "Theme": {
            "type": "object",
            "properties": {
                "name": {
                  "title": "主题名称",
                  "type": "string",
                  "ui:width": "33%",
                },
                "display": {
                  "title": "展示名称",
                  "type": "string",
                  "ui:width": "33%",
                },
                "hex": {
                  "title": "主题色号",
                  "type": "string",
                  "ui:width": "33%",
                }
            }
        }
      },
      required: [
        'name',
        'componentName',
        'themes',
        'title',
      ],
      properties: {
        name: {
          type: 'string',
          title: '模版名称',
        },
        componentName: {
          title: "模版 Component 名称",
          type: "string",
          // "enum": [
          //   "TemplateModern",
          //   "TemplateColumn",
          //   "TemplatePure",
          //   "TemplatePaper",
          //   "TemplateTimeline",
          //   "TemplateStandard"
          // ],
          // "enumNames": [
          //   "TemplateModern",
          //   "TemplateColumn",
          //   "TemplatePure",
          //   "TemplatePaper",
          //   "TemplateTimeline",
          //   "TemplateStandard"
          // ]
        },
        columns: {
          title: "模版栏数",
          "enum": [
            "one",
            "two"
          ],
          "enumNames": [
            "单栏",
            "双栏"
          ]
        },
        themes: {
          title: "模版主题",
          type: "array",
          items: {
            "$ref": "#/definitions/Theme"
          }
        },
        title: {
          type: 'string',
          title: '模版标题',
        },
        desc: {
          type: 'string',
          title: '模版描述',
          'ui:options': {
            placeholder: '请输入分类的描述',
            type: 'textarea',
            rows: 5
          }
        },
        publicLink: {
          type: 'string',
          title: '外链UUID',
          "ui:width": "50%",
        },
        isPro: {
          title: "是否收费模版",
          type: "boolean",
          "ui:width": "50%",
        },
        coverImage: {
          "anyOfSelect": {
              "ui:widget": "RadioWidget",
              "ui:title": "模版图片",
              "ui:options": {}
          },
          anyOf: [
            {
              title: "上传图片",
              type: "string",
              default: "",
              "ui:action": `${baseAPIURL}/api/upload`,
              "ui:with-credentials": true,
              "ui:list-type": "picture",
              "ui:widget": "UploadWidget",
              "ui:btnText": "上传头图"
            }, 
            {
              title: "直接填写URL",
              type: "string",
            }
          ]
        }
      }
    })
    
    const onCreateNew = () => {
      formData.value = {
        title: '',
        name: '',
        componentName: '',
        themes: [],
        desc: '',
        coverImage: '',
        columns: 'one',
        publicLink: '',
        isPro: false
      }
      dialogVisible.value = true
      editMode.value = ''  
    }
    const onCancel = () => {
      dialogVisible.value = false
    }
    const onSubmit = async () => {
      console.log(formData.value)
      if (editMode.value === '') {
        await store.dispatch('createTemplate', { data: formData.value })
        ElMessage({
          type: 'success',
          message: '创建成功',
          duration: 1000
        })
        dialogVisible.value = false
      } else {
        await store.dispatch('updateTemplate', { urlParams: { id: editMode.value }, data: formData.value })
        ElMessage({
          type: 'success',
          message: '更新成功',
          duration: 1000
        })
        dialogVisible.value = false
      }
    }
    const onUpdateSort = async (id: string, value: string) => {
      console.log(id, value)
      await store.dispatch('updateTemplate', { urlParams: { id }, data: { sort: parseInt(value) } })
      ElMessage({
        type: 'success',
        message: '更新成功',
        duration: 1000
      })
    }
    const onDelete = (id: string) => {
      ElMessageBox.confirm('是否要永久删除该模版？',  '删除模版', {
        confirmButtonText: '确认删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await store.dispatch('deleteTemplate', { urlParams: { id }})
        ElMessage({
          type: 'success',
          message: '删除成功',
          duration: 1000
        })
      }).catch((e) => {
        throw e
      })
    }
    onMounted(() => {
      store.dispatch('getTemplates')
    })
    return {
      templates,
      schema,
      formData,
      triggerEdit,
      dialogVisible,
      onCancel,
      onSubmit,
      onCreateNew,
      editMode,
      onDelete,
      isLoading,
      onUpdateSort
    }
  }
});
